import { Table, Container, Button, Row, Col } from 'reactstrap';
import React, { useEffect, useState } from 'react';
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
import "./Reports.css"
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
// import ReactTable from 'react-table';
// import ReactDOM from "react-dom"
// import { NumberWithCommas } from "../../share/NumberWithCommas";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report1916() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNew BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    const [Borrow1916data, setBorrow1916data] = useState([]);

    async function GetV1916() {
        const response1916 = await fetch("/api/BorrowReports/getV1916")
        const Borrow1916data = await response1916.json()
        setBorrow1916data(Borrow1916data.dataenum);
        // console.log(Borrow1916data)
    }
    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ที่', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สพร./สพน.', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ชื่อบริษัท', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สถานะ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงินกู้', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนผู้เข้าฝึกอบรม', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'จำนวนผู้เข้าทดสอบ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'เหตุผลของการกู้ยืม (ตอบได้มากกว่า 1 ข้อ)', colSpan: 8, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, {}, { text: 'ประโยชน์ที่ผู้ประกอบกิจการได้รับการกู้ยืมเงิน', colSpan: 8, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {},
    //     {}, { text: 'ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน', colSpan: 7, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, { text: 'ความพึงพอใจในการให้บริการ การอำนวยความสะดวก และการให้คำปรึกษาแนะนำของเจ้าหน้าที่', colSpan: 7, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, {}, {}, { text: 'ประสงค์จะใช้บริการเงินกู้ยืมเพิ่มเติมหรือไม่', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'คิดว่าอัตราดอกเบี้ยเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานร้อยละ 3 ต่อปี มีความเหมาะสมหรือไม่', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'คิดว่าเงินกู้ยืมกองทุนพัฒนาฝีมือแรงานมีประโยชน์ต่อการส่งเสริมการพัฒนาฝีมือแรงงานหรือไม่', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, { text: 'ทราบข่าวสารการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานจาก', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ปัญหาอุปสรรคการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อคิดเห็นและข้อเสนอแนะ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }],
        
    //     [{}, {}, {}, {}, {}, {}, { text: 'เข้า', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผ่าน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เข้า', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ผ่าน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ1', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ2', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ3', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ4', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ5', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ6', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ7', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ข้อ8', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ลดต้นทุน/ลดการสูญเสียในการผลิต', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เพิ่มผลิตภาพการผลิตสินค้า/บริการ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สินค้า/บริการ มีคุณภาพดีขึ้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เพิ่มความสามารถในการแข่งขันของบริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'พนักงานมีทักษะ ความรู้ ความชำนาญเพิ่มขึ้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ความผิดพลาดในการทำงานลดลง', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สามารถจำแนกระดับความรู้ความสามารถพนักงานในองค์กร', fillColor: '#cccccc', bold: true, alignment: 'center' },
    //     { text: 'สามารถปรับเพิ่มเงินเดือน เลื่อนตำแหน่งตามทักษะความรู้ความสามารถ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มีทักษะความรู้ความชำนาญในงานที่ทำเพิ่มขึ้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รู้ระดับความสามารถของตนเองเพื่อพัฒนาสมรรถนะที่ขาด', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'พัฒนาความรู้ความสามารถทันต่อเทคโนโลยี', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สามารถถ่ายทอดความรู้และสอนงานให้พนักงานในองค์กร', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'การทำงานเป็นระบบมีประสิทธิภาพเพิ่มขึ้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สามารถแก้ไขปัญหาข้อขัดข้องในการปฏิบัติงานได้', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ได้รับการปรับเพิ่มเงินเดือน เลื่อนตำแหน่งสูงขึ้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ให้คำปรึกษาแนะนำชี้แจงหลักเกณฑ์การให้กู้ยืมเงินกองทุนอย่างถูกต้อง ชัดเจน เข้าใจง่าย ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อำนวยความสะดวกในการจัดทำเอกสารการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มีความกระตือรือร้นและเต็มใจให้บริการด้วยความรวดเร็ว', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'สามารถตอบคำถาม ช่วยเหลือเมื่อมีข้อสงสัย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ช่องทางการชำระเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานมีความสะดวก', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ขั้นตอนการให้บริการมีความสะดวก รวดเร็ว', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'การประชาสัมพันธ์ข้อมูลข่าวสารการให้เงินกู้ยืมกองทุนพัฒนาฝีมือแรงงาน', fillColor: '#cccccc', bold: true, alignment: 'center' }, 
    //     { text: 'ต้องการ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่ต้องการ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เหมาะสม', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่เหมาะสม', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'มีประโยชน์', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ไม่มีประโยชน์', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จนท.กรมพัฒฯ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'Internet', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อื่นๆ', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}]];

    //     Borrow1916data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1 }, { text: item.approveOfficerBy, alignment: 'left' }, { text: item.employee, alignment: 'left' }, { text: item.trainEndDate + ' ' + ' / ' + ' ' + item.testEndDate, alignment: 'right' }, { text: item.status, alignment: 'right' }, { text: item.amountLimit, alignment: 'right' }, { text: item.employeeAmount, alignment: 'right' }, { text: item.employeePass, alignment: 'right' }, { text: '', alignment: 'right' }, { text: item.employeeTestPass, alignment: 'right' }, { text: item.reason1, alignment: 'right' }, { text: item.reason2, alignment: 'right' }, { text: item.reason3, alignment: 'right' }, { text: item.reason4, alignment: 'right' }, { text: item.reason5, alignment: 'right' }, { text: item.reason6, alignment: 'right' }, { text: item.reason7, alignment: 'right' }, { text: item.reason8, alignment: 'right' }, { text: item.companyBenefit1, alignment: 'right' }, { text: item.companyBenefit2, alignment: 'right' }, { text: item.companyBenefit3, alignment: 'right' }, { text: item.companyBenefit4, alignment: 'right' }, { text: item.companyBenefit5, alignment: 'center' }, { text: item.companyBenefit6, alignment: 'right' }, 
    //             { text: item.companyBenefit7, alignment: 'right' }, { text: item.employeeBenefit1, alignment: 'right' }, { text: item.employeeBenefit2, alignment: 'right' }, { text: item.employeeBenefit3, alignment: 'right' }, { text: item.employeeBenefit4, alignment: 'right' }, { text: item.employeeBenefit5, alignment: 'right' }, { text: item.employeeBenefit6, alignment: 'center' }, { text: item.employeeBenefit7, alignment: 'right' }, { text: item.satisfaction1, alignment: 'right' }, { text: item.satisfaction2, alignment: 'right' }, { text: item.satisfaction3, alignment: 'right' }, { text: item.satisfaction4, alignment: 'right' }, { text: item.satisfaction5, alignment: 'right' }, { text: item.satisfaction6, alignment: 'right' }, { text: item.satisfaction7, alignment: 'right' }, { text: item.want1, alignment: 'right' }, { text: item.want1, alignment: 'right' }, { text: item.want2, alignment: 'right' }, { text: item.want2, alignment: 'right' }, { text: item.want3, alignment: 'right' }, { text: item.want3, alignment: 'right' }, { text: item.social, alignment: 'right' }, { text: item.social, alignment: 'right' }, { text: item.social, alignment: 'right' }, { text: item.borrowNumber, alignment: 'right' }, { text: item.problem, alignment: 'right' }, { text: item.seggestion, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'แบบเก็บข้อมูลแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน (แบบ กย.6)', style: 'header', alignment: 'center', bold: true, fontSize: 20 },
    //             {
    //                 table: {
    //                     widths: [6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('1916')
    // }

    useEffect(() => {
        GetV1916()

    }, [])
    return (
        <Container>
             <Row className='my-3'>
                <Col className='d-flex justify-content-end'>
                    <Button className="btn border border-1 mx-1 btn-green" href={'api/BorrowReports/xlsxV1916'} download><RiFileExcel2Line/> Export Excel</Button>
                    <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1916`} download><AiOutlineFilePdf/> Export PDF</Button>
                </Col>
            </Row>
            {/* <Row>
                <Col className='d-flex justify-content-end' style={{ paddingTop: '20px' }}>
                    <Button className="btn1" href={'api/BorrowReports/xlsxV1916'} download>EXCEL</Button>
                    <Button className="btn2" href={`api/BorrowReports/pdfR1916`} download>PDF</Button>
                </Col>
            </Row> */}
            

                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="2" className=' text-center'>
                                    ที่
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    สพร./สพน.
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ชื่อบริษัท
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    วันที่จบฝึกอบรม/ทดสอบฯวันสุดท้าย
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    สถานะ
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    จำนวนเงินกู้
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    จำนวนผู้เข้าฝึกอบรม
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    จำนวนผู้เข้าทดสอบ
                                </th>
                                <th colSpan="8" className=' text-center'>
                                    เหตุผลของการกู้ยืม (ตอบได้มากกว่า 1 ข้อ)
                                </th>
                                <th colSpan="8" className=' text-center'>
                                    ประโยชน์ที่ผู้ประกอบกิจการได้รับจากการกู้ยืมเงิน
                                </th>
                                <th colSpan="7" className=' text-center'>
                                    ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </th>
                                <th colSpan="7" className=' text-center'>
                                    ความพึงพอใจในการให้บริการ การอำนวยความสะดวก และให้คำปรึกษาแนะนำของเจ้าหน้าที่
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    ประสงค์ใช้บริการเงินกู้ยืมเพิ่มเติมหรือไม่
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    คิดว่าอัตราดอกเบี้ยกู้ยืมเงินกองทุนฯร้อยละ3ต่อปี มีความเหมาะสมหรือไม่
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    ท่านคิดว่าเงินกู้ยืมกองทุนพัฒนาฝีมือแรงานมีประโยชน์ต่อการส่งเสริมการพัฒนาฝีมือแรงงานหรือไม่
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ทราบข่าวสารการให้กู้ยืมเงินกองทุนฯจาก
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ปัญหาอุปสรรคการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                </th>
                                <th rowSpan="2" className=' text-center'>
                                    ข้อคิดเห็นและข้อเสนอแนะ
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    เข้า
                                </th>
                                <th className=' text-center'>
                                    ผ่าน
                                </th>
                                <th className='text-center'>
                                    เข้า
                                </th>
                                <th className=' text-center'>
                                    ผ่าน
                                </th>
                                <th className=' text-center'>
                                    ข้อที่1
                                </th>
                                <th className=' text-center'>
                                    ข้อที่2
                                </th>
                                <th className=' text-center'>
                                    ข้อที่3
                                </th>
                                <th className=' text-center'>
                                    ข้อที่4
                                </th>
                                <th className=' text-center'>
                                    ข้อที่5
                                </th>
                                <th className=' text-center'>
                                    ข้อที่6
                                </th>
                                <th className=' text-center'>
                                    ข้อที่7
                                </th>
                                <th className=' text-center'>
                                    ข้อที่8
                                </th>
                                <th className=' text-center'>
                                    ลดต้นทุน/ลดการสูญเสียในการผลิต
                                </th>
                                <th className=' text-center'>
                                    เพิ่มผลิตภาพการผลิตสินค้า/บริการ
                                </th>
                                <th className=' text-center'>
                                    สินค้า/บริการมีคุณภาพดีขึ้น
                                </th>
                                <th className=' text-center'>
                                    เพิ่มความสามารถในการแข่งขันของบริษัท
                                </th>
                                <th className=' text-center'>
                                    พนักงานมีทักษะความรู้ความชำนาญเพิ่ม
                                </th>
                                <th className=' text-center'>
                                    ความผิดพลาดในการทำงานลดลง
                                </th>
                                <th className=' text-center'>
                                    สามารถจำแนกระดับความรู้ความสามารถพนักงานในองค์กร
                                </th>
                                <th className=' text-center'>
                                    สามารถปรับเพิ่มเงินเดือนเลื่อนตำแหน่งตามทักษะความรู้ความสามารถ
                                </th>
                                <th className=' text-center'>
                                    มีทักษะความรู้ความชำนาญในงานที่ทำเพิ่มขึ้น
                                </th>
                                <th className=' text-center'>
                                    รู้ระดับความรู้ความสามารถของตนเองเพื่อพัฒนาสมรรถนะที่ขาด
                                </th>
                                <th className=' text-center'>
                                    พัฒนาความรู้ความสามารถทันต่อเทคโนโลยี
                                </th>
                                <th className=' text-center'>
                                    สามารถถ่ายทอดความรู้ความสามารถและสอนงานให้พนักงานในองค์กร
                                </th>
                                <th className=' text-center'>
                                    การทำงานเป็นระบบมีประสิทธิภาพเพิ่มขึ้น
                                </th>
                                <th className=' text-center'>
                                    สามารถแก้ไขปัญหาข้อขัดข้องในการปฎิบัติงานได้
                                </th>
                                <th className=' text-center'>
                                    ได้รับการปรับเพิ่มเงินเดือนเลื่อนตำแหน่งสูงขึ้น
                                </th>
                                <th className=' text-center'>
                                    ให้คำปรึกษาแนะนำชี้แจงหลักเกณฑ์การให้กู้ยืมเงินกองทุนอย่างถูกต้องชัดเจนเข้าใจง่าย
                                </th>
                                <th className=' text-center'>
                                    อำนวยความสะดวกในการจัดทำเอกสารการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                </th>
                                <th className=' text-center'>
                                    มีความกระตือรือร้นและเต็มใจให้บริการด้วยความรวดเร็ว
                                </th>
                                <th className=' text-center'>
                                    สามารถตอบคำถามช่วยเหลือเมื่อมีข้อสงสัย
                                </th>
                                <th className=' text-center'>
                                    ช่องทางการชำระเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานมีความสะดวก
                                </th>
                                <th className=' text-center'>
                                    ขั้นตอนการให้บริการมีความสะดวกรวดเร็ว
                                </th>
                                <th className=' text-center'>
                                    การประชาสัมพันธ์ข้อมูลข่าวสารการให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน
                                </th>
                                <th className=' text-center'>
                                    ต้องการ
                                </th>
                                <th className=' text-center'>
                                    ไม่ต้องการ
                                </th>
                                <th className=' text-center'>
                                    เหมาะสม
                                </th>
                                <th className=' text-center'>
                                    ไม่เหมาะสม
                                </th>
                                <th className=' text-center'>
                                    มีประโยชน์
                                </th>
                                <th className=' text-center'>
                                    ไม่มีประโยชน์
                                </th>
                                <th className=' text-center'>
                                    จนท.กรมพัฒฯ
                                </th>
                                <th className=' text-center'>
                                    Internet
                                </th>
                                <th className=' text-center'>
                                    อื่นๆ
                                </th>
                            </tr>

                        </thead>
                        <tbody> {Borrow1916data.map((item, i) => (
                            <tr>
                                <th scope="row" className='text-center'>
                                    {i + 1}
                                </th>
                                <td className='text-start'>
                                    {item.approveOfficerBy}
                                </td>
                                <td className='text-start'>
                                    {item.employee}
                                </td>
                                <td className='text-end'>
                                    {item.trainEndDate + ' ' + ' / ' +  ' ' + item.testEndDate}
                                </td>
                                <td className='text-end'>
                                    {item.status}
                                </td>
                                <td className='text-end'>
                                    {item.amountLimit}
                                </td>
                                <td className='text-end'>
                                    {item.employeeAmount}
                                </td>
                                <td className='text-end'>
                                    {item.employeePass}
                                </td>
                                <td className='text-end'>
                                    {item.employTestTotal}
                                </td>
                                <td className='text-end'>
                                    {item.employeeTestPass}
                                </td>
                                <td className='text-end'>
                                    {item.reason1}
                                </td>
                                <td className='text-end'>
                                    {item.reason2}
                                </td>
                                <td className='text-end'>
                                    {item.reason3}
                                </td>
                                <td className='text-end'>
                                    {item.reason4}
                                </td>
                                <td className='text-end'>
                                    {item.reason5}
                                </td>
                                <td className='text-end'>
                                    {item.reason6}
                                </td>
                                <td className='text-end'>
                                    {item.reason7}
                                </td>
                                <td className='text-end'>
                                    {item.reason8}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit1}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit2}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit3}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit4}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit5}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit6}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit7}
                                </td>
                                <td className='text-end'>
                                    {item.companyBenefit8}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit1}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit2}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit3}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit4}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit5}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit6}
                                </td>
                                <td className='text-end'>
                                    {item.employeeBenefit7}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction1}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction2}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction3}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction4}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction5}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction6}
                                </td>
                                <td className='text-end'>
                                    {item.satisfaction7}
                                </td>
                                <td className='text-end'>
                                    {item.want1}
                                </td>
                                <td className='text-end'>
                                    {item.want1}
                                </td>
                                <td className='text-end'>
                                    {item.want2}
                                </td>
                                <td className='text-end'>
                                    {item.want2}
                                </td>
                                <td className='text-end'>
                                    {item.want3}
                                </td>
                                <td className='text-end'>
                                    {item.want3}
                                </td>
                                <td className='text-end'>
                                    {item.social}
                                </td>
                                <td className='text-end'>
                                    {item.social}
                                </td>
                                <td className='text-end'>
                                    {item.social}
                                </td>
                                <td className='text-end'>
                                    {item.problem}
                                </td>
                                <td className='text-end'>
                                    {item.seggestion}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>

        </Container>
    );


}